﻿import type { RouteRecordRaw } from 'vue-router'

const assetRoutes: RouteRecordRaw = {
  path: '/assets',
  name: 'Assets',
  redirect: '/assets/card',
  meta: { title: '固定资产', icon: 'icon-tool' },
  children: [
    { path: 'card', name: 'AssetCard', component: () => import('@/views/assets/CardList.vue'), meta: { title: '资产卡片', permissions: ['assets:card:view'] } },
    { path: 'depreciation', name: 'AssetDepreciation', component: () => import('@/views/assets/DepreciationList.vue'), meta: { title: '折旧计提', permissions: ['assets:depreciation:view'] } },
    { path: 'disposal', name: 'AssetDisposal', component: () => import('@/views/assets/DisposalList.vue'), meta: { title: '资产处置', permissions: ['assets:disposal:view'] } },
    { path: 'ledger', name: 'AssetLedger', component: () => import('@/views/assets/LedgerList.vue'), meta: { title: '资产台账', permissions: ['assets:ledger:view'] } },
  ],
}

export default assetRoutes
